import React from "react";
import { Box } from "@mui/material";
import { colors, fonts, gradients } from "../../theme/tokens";

const ServiceDetail = ({ service, index }) => {
  const num = String(index + 1).padStart(2, "0");

  return (
    <Box
      id={service.id}
      sx={{
        scrollMarginTop: "100px",
        background: "#fff",
        border: `1px solid ${colors.lineSoft}`,
        borderRadius: "26px",
        p: { xs: "30px 26px", md: "40px 42px" },
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: ".9fr 1.1fr" },
        gap: { xs: "28px", md: "44px" },
        boxShadow: "0 18px 44px -34px rgba(14,27,42,.5)",
      }}
    >
      {/* Left: identity */}
      <Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <Box
            sx={{
              fontFamily: fonts.display,
              fontWeight: 700,
              fontSize: "18px",
              color: "#fff",
              background: gradients.amber,
              width: "48px",
              height: "48px",
              borderRadius: "14px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flex: "none",
            }}
          >
            {num}
          </Box>
          <Box
            sx={{
              fontFamily: fonts.display,
              fontSize: "12.5px",
              fontWeight: 600,
              letterSpacing: ".04em",
              color: colors.steelBlue,
            }}
          >
            {service.tagline}
          </Box>
        </Box>
        <Box
          component="h2"
          sx={{
            fontFamily: fonts.display,
            fontWeight: 700,
            fontSize: "26px",
            lineHeight: 1.12,
            letterSpacing: "-.01em",
            color: colors.navyInk,
            mt: "20px",
            mb: 0,
          }}
        >
          {service.title}
        </Box>
        <Box
          sx={{
            fontFamily: fonts.body,
            fontSize: "15.5px",
            lineHeight: 1.7,
            color: colors.mutedText,
            mt: "14px",
          }}
        >
          {service.description}
        </Box>
      </Box>

      {/* Right: offerings */}
      <Box>
        <Box
          sx={{
            fontFamily: fonts.display,
            fontSize: "12px",
            fontWeight: 600,
            letterSpacing: ".16em",
            color: colors.subtleText,
            mb: "16px",
          }}
        >
          WHAT WE OFFER
        </Box>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
            gap: "10px 20px",
          }}
        >
          {service.offerings.map((o) => (
            <Box
              key={o}
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: "10px",
                fontFamily: fonts.body,
                fontSize: "14px",
                color: "#3C4D5E",
                lineHeight: 1.45,
                py: "8px",
                borderBottom: "1px solid #F0F3F7",
              }}
            >
              <Box
                component="span"
                sx={{
                  color: colors.amber,
                  mt: "1px",
                  flex: "none",
                  fontWeight: 700,
                }}
              >
                ✓
              </Box>
              {o}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default ServiceDetail;
